const addToDb = (time) => {
    localStorage.setItem("break-time", time);
};

const getStoredData = () => {
    const breakTime = localStorage.getItem("break-time");
    if (breakTime) {
        return breakTime;
    }
    return 0;
};

export {
    addToDb,
    getStoredData
};